import React, { Component } from 'react'
import './FieldMessage.scss'

type FieldMessageProps = {
  value?: string
  className?: string
  error?: Error | string
  dataCIKey?: string
}

export default class FieldMessage extends Component<FieldMessageProps, any> {
  state = {}

  render() {
    let classList = 'FieldMessage'
    let message: string | Error = this.props.value || ''

    if (this.props.className) {
      classList += ` ${this.props.className}`
    }

    if (this.props.error) {
      classList += ' is-error'
      message = this.props.error
    }

    if (Array.isArray(message)) {
      message = message.join(', ')
    }

    if ('object' === typeof message) {
      // catch malformed messages
      message = JSON.stringify(message)
    }

    return (
      <div data-ci={this.props.dataCIKey} className={classList}>
        {message}
      </div>
    )
  }
}
